import React, { Component } from "react";

class ToggleHelp extends Component {
  state = {
    help: localStorage.getItem("help")
  };
  toggleHelpOnOff = () => {
    this.setState({ help: !localStorage.getItem("help") });
    localStorage.setItem("help", !localStorage.getItem("help"));
  };

  render() {
    return (
      <div className="align-middle" onClick={event => this.toggleHelpOnOff()}>
        {/* Releaseinfo <FontAwesomeIcon icon={this.state.help ? "toggle-on": "toggle-off"} className={this.state.help ? "text-success": "text-danger"} size="2x"/> */}
      </div>
    );
  }
}
export default ToggleHelp;
